// AudioStreamSender.ts
import logger from '@/utils/logger';

export class HxxlConfig {
  
  private owner: string | null = null;

  private uid: string | null = null;

  private talkId: string | null = null;

  constructor() {
    const params = new URLSearchParams(window.location.search);
    this.owner = params.get('owner');
    this.uid = params.get('uid');
    this.talkId = params.get('talkId');    
    logger.log('HxxlConfig : ', this);
  }
  
  getOwner() {
    return this.owner;
  }
  
  getUid() {
    return this.uid;
  }
  
  getTalkId() {
    return this.talkId;
  }

  haveParams() {
    return this.owner || this.uid || this.talkId;
  }
}
const globalHxxlConfig = new HxxlConfig();

export default globalHxxlConfig;
